import { createContext, useContext } from 'react';
import { IPermissionCheck } from '~/src/dash/utils/permission_service';
import { IOfferNewConfig } from '~/src/dash/views/platform-connect/DraftOfferNew/config';

interface IPlatformConnectDraftOfferNewContext {
  cfg: IOfferNewConfig;
  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
}

export const PlatformConnectDraftOfferNewContext = createContext(
  {} as IPlatformConnectDraftOfferNewContext,
);
export const usePlatformConnectDraftOfferNewStore = (): IPlatformConnectDraftOfferNewContext =>
  useContext(PlatformConnectDraftOfferNewContext);
